import { render } from "./RolePermissionWithComponent.vue?vue&type=template&id=68194668&scoped=true"
import script from "./RolePermissionWithComponent.vue?vue&type=script&lang=js"
export * from "./RolePermissionWithComponent.vue?vue&type=script&lang=js"

import "./RolePermissionWithComponent.vue?vue&type=style&index=0&id=68194668&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68194668"]])

export default __exports__